<template>
  <div class="min-h-screen w-full bg">
    <RouterView />
  </div>
</template>
<style scoped>
.bg {
  background-color: var(--p-surface-50);
}
</style>
